import { render, staticRenderFns } from "./UpdateNotificationBanner.vue?vue&type=template&id=edda1ff8&scoped=true"
import script from "./UpdateNotificationBanner.vue?vue&type=script&lang=js"
export * from "./UpdateNotificationBanner.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotificationBanner.vue?vue&type=style&index=0&id=edda1ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda1ff8",
  null
  
)

export default component.exports